import React from 'react'
import {FaMapMarked, FaPhone} from 'react-icons/fa'
import {MdEmail} from 'react-icons/md'
import {GoLinkExternal} from 'react-icons/go'
import './MainContent.css'

const days = [
    ["Lunes - Viernes", "Abierto"],
    ["Sábado", "Mañanas"],
    ["Domingo", "Cerrado"]
]

const week_day = (day) =>{
    return(
        <div className="week_day">
            <p className="estado_label">{day[0]}</p>
            <p>{day[1]}</p>
        </div>
    )
}

export class ContactCard extends React.Component{
    render(){
        var week_days_map = days.map(function(choosen_day){
            return week_day(choosen_day)
        })
        
        return(
                <div className="contact_card_container">
                    <div className="horario_container">
                        <h2 className="container_title">
                            Horario de apertura
                        </h2>
                        <div className="horario_inner_container">
                            <div className="horario_day_container">
                                {week_days_map}
                            </div>
                            <div className="horario_apertura_table">
                                <div className="season_table">
                                    <h3>Invierno :</h3>
                                    <div>
                                        <p>Mañanas: 9:00 - 14:00</p>
                                        <p>Tardes: 16:00 - 19:00</p>
                                    </div>
                                </div> 
                                <div className="season_table">
                                    <h3>Verano :</h3>
                                    <div>
                                        <p>Mañanas: 8:30 - 14:00</p>
                                        <p>Tardes: 16:30 - 19:00</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="barra_separatoria_menudo_nombre" />
                    <div className="contacto_container">
                        <h2 className="container_title">
                            Contacto
                        </h2>
                        <div>
                            <h4 className="contacto_inner_text"> <FaMapMarked/>  Dirección</h4>
                            Calle Tomelloso, 14, 13005 Ciudad Real, Cdad. Real <a href="https://goo.gl/maps/wAJHhjiPasdeK6cb7" target="_blank" style={{color: '#f2f2f2'}}>(Mapa  <GoLinkExternal/>)</a>
                            <h4 className="contacto_inner_text"> <MdEmail/>  Email</h4>
                            contacto@servidiesel.es
                            <h4 className="contacto_inner_text"> <FaPhone/>  Teléfono</h4>
                            Fijo: 926210564 | Móvil: 659913596
                        </div>
                    </div>
                </div>
        )
    }
}